export function getLastWeekDates() {
  // week is defined as From Monday To Sunday.
  let d1 = new Date();
  //when we do d1.getDay() = 0 is sunday, 6 is saturday
  // let lastDay = new Date(d1.getFullYear, )
  let currentDay = d1.getDay();
  let currentDate = d1.getDate();
  console.log(currentDate, currentDay);
  if (currentDay == 0) currentDay = 7;

  let lastDayOfLastWeek = new Date(
    d1.getFullYear(),
    d1.getMonth(),
    currentDate - currentDay,
    23,
    59,
    59
  );

  let firstDayOfLastWeek = new Date(
    d1.getFullYear(),
    d1.getMonth(),
    currentDate - currentDay - 6
  );

  return [firstDayOfLastWeek, lastDayOfLastWeek];
}

export function getLastMonthDates() {
  let d1 = new Date();
  console.log();
  let firstDayOfLastMonth = new Date(d1.getFullYear(), d1.getMonth() - 1, 1);
  let lastDayOfLastMonth = new Date(
    d1.getFullYear(),
    d1.getMonth(),
    0,
    23,
    59,
    59
  );

  return [firstDayOfLastMonth, lastDayOfLastMonth];
}

export function getMonthName(date) {
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  console.log("form month name function");
  console.log(date);
  let m = new Date(date).getMonth();

  return month[m];
}
